import { CurrencyPipe, DatePipe, PercentPipe } from '@angular/common';
import { Injectable } from '@angular/core';

@Injectable({ 
    providedIn: 'root' 
})
export class TransformationService {
  constructor(private currencyPipe:CurrencyPipe, private percentPipe:PercentPipe, private datePipe:DatePipe) {}

  public bidValuesOnly(value:string,withDecimals:boolean){
    if(value){
      //only positive numbers potentially with $ sign up and one decimal sign are accepted.
      let hasCurrencySymbol=false;
      value=value.replace(/[^0-9.$]+/g,"");; //strip off anything not desired
      if(value.length>0 && value.startsWith('$')) hasCurrencySymbol=true;
      value = value.substring(hasCurrencySymbol?1:0).replace(/[^0-9.]+/g,""); //reduce to numbers and decimal
      if(value.length>0) {
        //make sure only one decimal survives
        let decimalIndex = value.indexOf('.');
        if (decimalIndex>0){
          if(!withDecimals) value = value.substring(0,decimalIndex+1) + value.substring(decimalIndex+1).replace(/[1-9]+/g,"0");
          else value = value.substring(0,decimalIndex+1) + value.substring(decimalIndex+1).replace(/[^0-9]+/g,"");
        } 
      }
      return hasCurrencySymbol?('$'+value):value; 
    }
    else return undefined;
  }

  public transformAmount(value:any, withDecimals: boolean) {
    var number;
    if (typeof value === 'string') number = this.numberFromString(value, withDecimals);
    else number = value;

    if (number !== null && number !== undefined) {
      const hasDecimals = number % 1 !== 0;
      const useDecimals = withDecimals || hasDecimals;
      return useDecimals
        ? this.currencyPipe.transform(number, undefined, undefined, '1.2-2')
        : this.currencyPipe.transform(Math.floor(number), undefined, undefined, '1.0-0');
    } else {
      return undefined;
    }
  }

  public numberFromString(value: string|undefined, withDecimals: boolean) {
    if (value) {
      value = this.bidValuesOnly(value, true); // always preserve real decimals when parsing
      if (value?.length && value.startsWith('$')) value = value.substring(1);
      if (!value ||value.length === 0) return undefined;

      var n = Number(value);
      if (Number.isNaN(n)) return undefined;

      if (!withDecimals && n % 1 !== 0) {
        // caller didn't want decimals, but there are none-zero decimals — keep them (per your rule)
      }
      return n;
    } else {
      return undefined;
    }
  }

  public transformAmountIfNumber( value:any, withDecimals:boolean=true){
    var result;
    if(typeof value === 'string') result = this.numberFromString(value,withDecimals);
    else result=value;
    if(result) return this.currencyPipe.transform(result);
    else return value;
  }

  public transformPercent(value:any, withDecimals: boolean = true) {
    //this will ALWAYS transform with decimals if the amount has fractionals
    var number;
    if (typeof value === 'string') number = this.numberFromString(value, withDecimals);
    else number = value;

    if (number && number != null) {
      const hasDecimals = number % 1 !== 0;
      const useDecimals = withDecimals || hasDecimals;
      return useDecimals
        ? this.percentPipe.transform(number / 100, '1.2-2')
        : this.percentPipe.transform(number / 100, '1.0-0');
    } else {
      return undefined;
    }
  }

  public transformDate(value:Date){
    if(value) return this.datePipe.transform(value,'short');
    else return undefined;
  }

  public getTimeZone(d:Date){
    return d?.toLocaleString('en', {timeZoneName:'short'}).split(' ').pop();
  }

  public nthNumber(number:number){
    if (number > 3 && number < 21) return "th";
    switch (number % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  }
}